import $fn from '@/utils/fn.ts';
import httpApi from '@/apis/httpApi'
import http from "@/utils/http.js"

// 我买的/我卖的订单
interface BuyOrderJson {
    identity: string,
    status: string,
    page: number,
    size: number
}
export const buyOrder = (json: BuyOrderJson): any => http.httpGet({
    url: httpApi.order.buyOrder,
    json,
})

// 指定我的订单
interface MycommodityJson {
    page: number,
    size: number
}
export const mycommodity = (json: MycommodityJson): any => http.httpGet({
    url: httpApi.order.mycommodity,
    json,
})

// 买家订单详情
interface PurchaseDetaillJson {
    order_id: string
}
export const purchaseDetail = (json: PurchaseDetaillJson): any => http.httpGet({
    url: httpApi.order.purchaseDetail,
    json,
})

// 卖家订单详情
export const sellDetail = (json: PurchaseDetaillJson): any => http.httpGet({
    url: httpApi.order.sellDetail,
    json,
})

// 取消订单
export const orderCancel = (json: PurchaseDetaillJson): any => http.httpGet({
    url: httpApi.order.orderCancel,
    json,
})

// 删除订单
export const orderDel = (json: PurchaseDetaillJson): any => http.httpGet({
    url: httpApi.order.orderDel,
    json,
})

// 下单
interface PlaceJson {
    commodity_id: string,
    account: string,
    role_id: unknown,
    server_id: string
}
export const place = (json: PlaceJson): any => http.httpPost({
    url: httpApi.order.place,
    json
})
